import React, { useMemo, useState, useEffect } from "react";
import { Drawer, Form, DatePicker, Select, Checkbox, Divider, Icon } from "antd";
import moment from "moment";
import axios from "axios";

const { Option } = Select;

function DrawerSelecionarTurmas({ visible, onClose, turnos = [], edicoes = [], categorias = [], form, onConfirm }) {
    const { getFieldDecorator, getFieldValue, setFieldsValue, validateFields } = form;

    const [filtroEdicao, setFiltroEdicao] = useState(null);
    const [filtroCategoria, setFiltroCategoria] = useState(null);
    const [filtroTurno, setFiltroTurno] = useState(null);
    const [turmas, setTurmas] = useState([]);
    const [loadingTurmas, setLoadingTurmas] = useState(false);

    const selectedIds = getFieldValue("turmasSelecionadas") || [];

    const mostrarLista = !!(filtroEdicao || filtroCategoria);

    const allIds = useMemo(() => turmas.map(t => t.id), [turmas]);
    const allChecked = allIds.length > 0 && selectedIds.length === allIds.length;
    const indeterminate = selectedIds.length > 0 && selectedIds.length < allIds.length;

    const salvarDisabled = selectedIds.length === 0 || !mostrarLista;

    useEffect(() => {
        if (!mostrarLista) {
            setTurmas([]);
            setFieldsValue({ turmasSelecionadas: [] });
            return;
        }

        setLoadingTurmas(true);
        axios
            .get("/api/gestao-turmas/listar-turmas-ministradas", {
                params: {
                    filtroOrganismo: JSON.parse(localStorage.getItem("escola_selecionada")).id,
                    filtroEdicao: filtroEdicao || null,
                    filtroCategoria: filtroCategoria || null,
                    filtroTurno: filtroTurno || null
                }
            })
            .then(response => {
                setTurmas(response.data);
                const novosIds = response.data.map(t => t.id);
                const selecionadosValidos = selectedIds.filter(id => novosIds.includes(id));
                setFieldsValue({ turmasSelecionadas: selecionadosValidos });
            })
            .catch(() => setTurmas([]))
            .finally(() => setLoadingTurmas(false));
    }, [filtroEdicao, filtroCategoria, filtroTurno, mostrarLista]);

    const afterVisibleChange = v => {
        if (!v) {
            form.resetFields();
            setFiltroEdicao(null);
            setFiltroCategoria(null);
            setFiltroTurno(null);
            setTurmas([]);
        }
    };

    const onToggleAll = e => {
        setFieldsValue({ turmasSelecionadas: e.target.checked ? allIds : [] });
    };

    const handleConfirm = () => {
        validateFields((err, values) => {
            if (!err) {
                onConfirm(values.dataEmissao, values.turmasSelecionadas, filtroEdicao);
            }
        });
    };

    return (
        <Drawer
            title="Selecionar Turmas"
            placement="right"
            className="drawer-add-cursos"
            maskClosable={false}
            closable={true}
            onClose={onClose}
            visible={visible}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-add-curso">
                    <Form.Item label="Data de emissão">
                        {getFieldDecorator("dataEmissao", {
                            initialValue: moment(),
                            rules: [{ required: true, message: "Campo obrigatório" }]
                        })(<DatePicker format="DD-MM-YYYY" placeholder="Selecionar" suffixIcon={false} clearIcon={false} />)}
                    </Form.Item>

                    <Form.Item label="Edição">
                        {getFieldDecorator("filtroEdicao", {
                            rules: [{ required: true, message: "Campo obrigatório" }]
                        })(
                            <Select
                                placeholder="Edição"
                                disabled={!edicoes.length}
                                allowClear
                                onChange={value => setFiltroEdicao(value || null)}
                            >
                                {edicoes.map(edicao => (
                                    <Option value={edicao.id} key={edicao.id}>
                                        {edicao.nome}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item label="Nível">
                        <Select
                            placeholder="Nível"
                            disabled={!categorias.length}
                            allowClear
                            onChange={value => setFiltroCategoria(value || null)}
                        >
                            {categorias.map(categoria => (
                                <Option value={categoria.id} key={categoria.id}>
                                    {categoria.nome}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Turno">
                        <Select
                            placeholder="Selecionar"
                            disabled={!turnos.length}
                            allowClear
                            onChange={value => setFiltroTurno(value || null)}
                        >
                            {turnos.map(turno => (
                                <Option key={turno.id} value={turno.id}>
                                    {turno.nome}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <h3 style={{ paddingTop: 10 }}>Lista de Turmas</h3>

                    <Divider />

                    {mostrarLista && (
                        <Form.Item>
                            {!loadingTurmas && turmas.length > 0 && (
                                <div style={{ marginBottom: 12 }}>
                                    <Checkbox indeterminate={indeterminate} checked={allChecked} onChange={onToggleAll}>
                                        Todos
                                    </Checkbox>
                                </div>
                            )}

                            {getFieldDecorator("turmasSelecionadas", {
                                initialValue: []
                            })(
                                <Checkbox.Group style={{ width: "100%" }}>
                                    {loadingTurmas ? (
                                        <div style={{ textAlign: "center", padding: 20 }}>
                                            <Icon type="loading" style={{ fontSize: 28 }} />
                                        </div>
                                    ) : turmas.length === 0 ? (
                                        <span>Nenhuma turma encontrada</span>
                                    ) : (
                                        turmas.map(turma => (
                                            <div key={turma.id} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                                <Checkbox value={turma.id}>{turma.nome}</Checkbox>
                                            </div>
                                        ))
                                    )}
                                </Checkbox.Group>
                            )}
                        </Form.Item>
                    )}
                </Form>
            </div>

            <div className="ant-drawer-footer">
                <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </button>

                <button className="botao-principal" onClick={handleConfirm} disabled={salvarDisabled}>
                    Carregar
                </button>
            </div>
        </Drawer>
    );
}

export default Form.create()(DrawerSelecionarTurmas);
